<template>
  <div class="va-row calcendarWrapper" id="calcendarWrapper">
    <div class="flex md8 xs12">
      <FullCalendar
        class="calcendarWrapper-calendar"
        ref="fullCalendar"
        defaultView="dayGridMonth"
        defaultDate="2019-10-18"
        :header="{
          left: 'prev',
          center: 'title',
          right: 'next'
        }"
        :plugins="calendarPlugins"
        :weekends="true"
        :selectable="true"
        :editable="false"
        :droppable="false"
        :events="calendarEvents"
        @dateClick="handleDateClick"
      />
    </div>

    <div class="flex md4 xs12">
      <vuestic-card class="result" stripe="success">
        <p slot="title" v-cloak>
          {{ $t('newSettlement.totalBalance') }}
          <el-tooltip
            content="Order amount, including fees."
            placement="top"
            effect="light"
            popper-class="vue-tips"
          >
            <el-button class="btn-unblock">
              <span aria-hidden="true" class="entypo entypo-help wenhao"></span>
            </el-button>
          </el-tooltip>
        </p>
        <ul
          id="total_balance"
          class="well"
          style="max-width: max-content; padding: 16px"
          v-for="(value,key) in totalMoney"
        >
          <li style="list-style-type: none;" class="item-money">
            <span style="margin-right: 16px;" v-cloak>{{ key }}</span>
            <span style="float: right" v-cloak>{{ formatAmount(value) }}</span>
          </li>
        </ul>
        <div class="card-separator"></div>
        <h5 class="vuestic-card__title card-title">
          <p v-cloak>{{ $t('newSettlement.settlementAmount') }}</p>
        </h5>
        <ul
          id="settlementAmount"
          class="well"
          style="min-width: 20px; max-width: max-content; padding: 16px"
          v-if="Object.keys(selectedDealData).length === 0"
        >
          <li style="list-style-type: none;" class="item-money">
            <span style="margin-right: 16px;">&nbsp;</span>
            <span style="float: right">&nbsp;</span>
          </li>
        </ul>
        <ul
          id="settlementAmount"
          class="well"
          style="min-width: 20px; max-width: max-content; padding: 16px"
          v-else
          v-for="(item,i) in selectedDealData"
        >
          <li style="list-style-type: none;" class="item-money">
            <span style="margin-right: 16px;" v-cloak>{{ i }}</span>
            <span style="float: right" v-cloak>{{ formatAmount(item) }}</span>
          </li>
        </ul>
        <p class="pt-3 mb-0">
          <button
            class="btn btn-primary btn-sm"
            @click="updateNewDeal"
            v-cloak
          >{{ $t('basic.button.confirm') }}</button>
        </p>
      </vuestic-card>
    </div>

    <button class="btn btn-primary focus btn-sm" id="backParent" @click="goBack">{{ $t("back") }}</button>
  </div>
</template>

<script>
import Vue from "vue";
import FullCalendar from "@fullcalendar/vue/";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { request, compareDate, deepClone } from "../../utils/utils.js";
import { Tooltip } from "element-ui";
import { toMoment, toDuration } from "@fullcalendar/moment";
import BigNumber from "bignumber.js/bignumber.mjs";
import $jq from "jquery";
Vue.use(Tooltip);
var _ = require("lodash");
var moment = require("moment");

var fmt = {
  prefix: "",
  decimalSeparator: ".",
  groupSeparator: ",",
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: "",
  fractionGroupSize: 2,
  suffix: ""
};

export default {
  name: "ApplyA_Settlement",
  components: {
    FullCalendar
  },
  data: function() {
    return {
      dealData: {},
      selectedDealData: {},
      calendarPlugins: [
        dayGridPlugin,
        interactionPlugin
      ],
      calendarWeekends: true,
      calendarEvents: [],
      startDay: "",
      selectedDay: "",
      lastDealDay: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      totalMoney: 0
    };
  },
  computed: {
    isMobile: function() {
      if(document.body.clientWidth && document.body.clientWidth < 750) {
        return "mobile";
      }
      return "pc";
    }
  },
  methods: {
    formatAmount(str) {
      return str.decimalPlaces(2).toFormat(3, 2, fmt).slice(0, -1);
    },
    init() {
      let wrapBody = document.querySelector(".vuestic-widget-body");
      wrapBody.offsetHeight === 54
        ? (document.getElementById("backParent").style.top = "106px")
        : (document.getElementById("backParent").style.top = "126px");
      if(this.isMobile === 'mobile') {
        let backBtn = document.getElementById("backParent");
        backBtn.style.top = "10px"
        backBtn.style.left = "5px"
        backBtn.style.padding = "5px 8px"
        backBtn.style.lineHeight = 1
      }
    },
    goBack() {
      this.$router.push({
        name: "Settlement"
      });
    },
    getInit() {
      // 获取结算每日详细数据
      let token = localStorage.getItem("Authorization");
      request({
        method: "post",
        url: `/api/dashboard/settle/getDailyDetail?access_token=${token}`,
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      })
        .then(async res => {
          if (res.status === 200) {
            let respData = res.data;
            this.startDay = respData.data.start_date;
            this.selectedDay = this.startDay;
            let realDealData = deepClone(respData.data);
            delete realDealData.start_date;
            this.dealData = realDealData;
            await window.sessionStorage.setItem("startdata", this.startDay);
            let arr = $jq("tbody").find($jq(".fc-day")); //-top
            arr.each(function(i, v) {
              $jq(v).attr("id", $jq(v).attr("data-date"));
            });
            this.getEvents(this.dealData);
            this.getTotalBalance(this.dealData);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEvents(eventData) {
      this.calendarEvents = [];
      let firstDay = {};
      firstDay = {
        start: this.startDay,
        end: moment(this.startDay)
          .add(1, "days")
          .format("YYYY-MM-DD"),
        overlap: true,
        rendering: "background"
      };
      let events = [];
      events.push(firstDay);
      if (eventData[this.startDay]) {
        // firstDay.title = eventData[this.startDay]
        let len = Object.keys(eventData[this.startDay]).length;
        if (len === 1) {
          firstDay.title =
            Object.keys(eventData[this.startDay])[0] +
            " " +
            Object.values(eventData[this.startDay])[0];
          events.push(firstDay);
        } else {
          let multiNo1Events = {}; // key的命名是 "_"+key+'firstDay'
          for (let FirstDayKey in eventData[this.startDay]) {
            multiNo1Events["_" + FirstDayKey + "firstDay"] = {
              ...{},
              ...firstDay,
              title: `${FirstDayKey} ${eventData[this.startDay][FirstDayKey]}`
            };
            events.push(multiNo1Events["_" + FirstDayKey + "firstDay"]);
          }
        }
      } // 添加完了所有的first 事件

      // 添加其他日期的事件
      let otherEventData = deepClone(eventData);
      delete otherEventData[this.startDay];
      for (let otherDayKey in otherEventData) {
        let dateObj = { start: otherDayKey };
        let title = {};
        if (Object.keys(otherEventData[otherDayKey]).length === 1) {
          title = {
            title: `${Object.keys(otherEventData[otherDayKey])[0]} ${
              Object.values(otherEventData[otherDayKey])[0]
            }`
          };
          let _event = { ...{}, ...dateObj, ...title };
          events.push(_event);
        } else {
          for (let eventKey in otherEventData[otherDayKey]) {
            title = {
              title: `${eventKey} ${otherEventData[otherDayKey][eventKey]}`
            };
            let _event2 = { ...{}, ...dateObj, ...title };
            events.push(_event2);
          }
        }
      }
      this.calendarEvents = events;
    },
    updateNewDeal() {
      // 提交用户最后选择的日期
      let token = localStorage.getItem("Authorization");
      this.startDay = "2018-10-12";
      this.selectedDay = "2018-10-31";
      request({
        method: "put",
        url: `/api/dashboard/settle/apply?access_token=${token}&start_date=${this.startDay}&end_date=${this.selectedDay}`,
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.status === 200) {
            let respData = res.data;
            if (respData.code === "10000") {
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '<strong style="font-size:1rem;">' +
                  respData.msg +
                  "</strong>",
                center: true,
                duration: 1200,
                type: "success"
              });
              // 跳转到settlement页面
              this._.delay(() => {
                this.goBack();
              }, 1500);
            } else {
              // 交易失败，提示失败信息
              this.$message({
                dangerouslyUseHTMLString: true,
                message:
                  '<strong style="font-size:1rem;">' +
                  respData.msg +
                  "</strong>",
                center: true,
                duration: 1200,
                type: "error"
              });
              this._.delay(() => {
                this.goBack();
              }, 1500);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 加载一些数据的默认值
    handleDateClick(info) {
      this.loadJqRiLi();
      window.sessionStorage.setItem("endData", info.dateStr);
      $jq("tbody")
        .find($jq("#" + info.dateStr + ""))
        .nextAll()
        .css("background", "");
      $jq("tbody")
        .find($jq("#" + info.dateStr + ""))
        .parents(".fc-row")
        .nextAll()
        .find(".fc-day")
        .css("background", "");
      $jq("tbody")
        .find($jq("#" + info.dateStr + ""))
        .parents(".fc-row")
        .prevAll()
        .find(".fc-day")
        .css("background", "#1abc9c");
      $jq("tbody")
        .find($jq("#" + info.dateStr + ""))
        .prevAll()
        .css("background", "#1abc9c");
      $jq("tbody")
        .find($jq("#" + this.startDay + ""))
        .parents(".fc-row")
        .prevAll()
        .find(".fc-day")
        .css("background", "");
      $jq("tbody")
        .find($jq("#" + this.startDay + ""))
        .prevAll()
        .css("background", "");
      let addFg = false;
      if(info.dayEl.style.backgroundColor) {
        info.dayEl.style.backgroundColor = '';
        addFg = false;
      } else {
        if(moment(info.dateStr).isBetween(moment(this.startDay).subtract(1, 'day'), moment(this.lastDealDay).add(1, 'day'), 'day')) {
          info.dayEl.style.backgroundColor = '#1abc9c';
          addFg = true;
        } else {
          info.dayEl.style.backgroundColor = '';
          addFg = false;
        }
      }
      if(!addFg) {
        this.selectedDay = moment(info.dateStr).subtract(1, 'day').format('YYYY-MM-DD')
      }
      this.getSelectAmount(this.startDay, info.dateStr, this.dealData, addFg)
    },
    loadJqRiLi() {
      $jq(document).ready(function() {
        var startDate, endDate;
        // //上翻页事件
        $jq(".fc-left").click(".fc-icon", function() {
          // 遍历界面中所显示的日期
          let arr = $jq("tbody").find($jq(".fc-day"));
          arr.each(function(i, v) {
            $jq(v).attr("id", $jq(v).attr("data-date"));
          });
          startDate = window.sessionStorage.getItem("startdata");
          endDate = window.sessionStorage.getItem("endData") ? window.sessionStorage.getItem("endData") : startDate;
          var newdate = $jq("tbody").find(".fc-day").attr("id").replace(/\-/g, "");
          var replacef = $jq("tbody").find(".fc-day").attr("id");
          var replacee = $jq("tbody").find(".fc-day").last().attr("id");
          var last = $jq("tbody").find(".fc-day").last().attr("id").replace(/\-/g, "");
          var start = startDate.replace(/\-/g, "");
          var end = endDate.replace(/\-/g, "");
          if (newdate > start) {
            $jq("tbody").find(".fc-day").css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + replacef + "")).css("background", "");
            $jq("tbody").find($jq("#" + replacef + "")).nextAll().css("background", "");
            $jq("tbody").find($jq("#" + replacef + "")).parents(".fc-row").nextAll().find(".fc-day").css("background", "");
            $jq("tbody").find($jq("#" + endDate + "")).css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).prevAll().css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).parents(".fc-row").prevAll().find(".fc-day").css("background", "#1abc9c");
            if (end > last) {
              $jq("tbody").find($jq("#" + replacee + "")).css("background", "#1abc9c");
              $jq("tbody").find($jq("#" + replacee + "")).prevAll().css("background", "#1abc9c");
              $jq("tbody").find($jq("#" + replacee + "")).parents(".fc-row").prevAll().find(".fc-day").css("background", "#1abc9c");
            }
          } else {
            $jq("tbody").find($jq("#" + startDate + "")).css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + startDate + "")).parents(".fc-row").nextAll().find(".fc-day").css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + startDate + "")).nextAll().css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).parents(".fc-row").nextAll().find(".fc-day").css("background", "");
            $jq("tbody").find($jq("#" + endDate + "")).nextAll().css("background", "");
          }
        });

        // 下翻页事件
        $jq(".fc-right").on("click", ".fc-icon", function() {
          // 遍历界面中所显示的日期
          let arr = $jq("tbody").find($jq(".fc-day")); //-top
          arr.each(function(i, v) {
            $jq(v).attr("id", $jq(v).attr("data-date"));
          });
          startDate = window.sessionStorage.getItem("startdata");
          endDate = window.sessionStorage.getItem("endData") ? window.sessionStorage.getItem("endData") : startDate;
          var newdate = $jq("tbody").find(".fc-day").last().attr("id").replace(/\-/g, "");
          var replacef = $jq("tbody").find(".fc-day").attr("id");
          var replacee = $jq("tbody").find(".fc-day").last().attr("id");
          var first = $jq("tbody").find(".fc-day").attr("id").replace(/\-/g, "");
          var start = startDate.replace(/\-/g, "");
          var end = endDate.replace(/\-/g, "");

          if (newdate < end) {
            $jq("tbody").find(".fc-day").css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + replacee + "")).css("background", "");
            $jq("tbody").find($jq("#" + replacee + "")).prevAll().css("background", "");
            $jq("tbody").find($jq("#" + replacee + "")).parents(".fc-row").prevAll().find(".fc-day").css("background", "");
            $jq("tbody").find($jq("#" + startDate + "")).parents(".fc-row").nextAll().find(".fc-day").css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + startDate + "")).nextAll().css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + startDate + "")).css("background", "#1abc9c");
            if (start < first) {
              $jq("tbody").find($jq("#" + replacef + "")).css("background", "#1abc9c");
              $jq("tbody").find($jq("#" + replacef + "")).nextAll().css("background", "#1abc9c");
              $jq("tbody").find($jq("#" + replacef + "")).parents(".fc-row").nextAll().find(".fc-day").css("background", "#1abc9c");
            }
          } else {
            $jq("tbody").find($jq("#" + startDate + "")).css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).prevAll().css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + endDate + "")).parents(".fc-row").prevAll().find(".fc-day").css("background", "#1abc9c");
            $jq("tbody").find($jq("#" + startDate + "")).parents(".fc-row").prevAll().find(".fc-day").css("background", "");
            $jq("tbody").find($jq("#" + startDate + "")).prevAll().css("background", "");
          }
        });
      });
    },
    // 获取选中的日期的金额
    getSelectAmount(start, end, eventData, addFg) {
      this.selectedDealData = {};
      if (!addFg) {
        end = moment(end)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
      }
      let eventDays = Object.keys(eventData);
      let mustDays = [];
      var map = {};
      for (let item of eventDays) {
        if (compareDate(item, end, "equal")) {
          mustDays.push(item);
          if (
            moment(item).isBetween(moment(start).subtract(1, "day"), moment(this.lastDealDay).add(1, "day"), "day")
          ) {
            for (let title in eventData[item]) {
              let amount = new BigNumber(eventData[item][title]);
              if (map[title]) {
                map[title] = map[title].plus(amount);
              } else {
                map[title] = amount;
              }
            }
          }
        }
      }
      this.selectedDealData = map;
      return map;
    },
    getTotalBalance(allData) {
      let monenyObj = Object.values(allData);
      let kinds = {};
      for (let element of monenyObj) {
        if (Object.keys(element).length === 1) {
          if (typeof kinds[Object.keys(element)[0]] === "undefined") {
            kinds[Object.keys(element)[0]] = new BigNumber(
              Object.values(element)[0]
            );
          } else {
            kinds[Object.keys(element)[0]] = kinds[
              Object.keys(element)[0]
            ].plus(new BigNumber(Object.values(element)[0]));
          }
        } else {
          for (let key in element) {
            if (typeof kinds[key] === "undefined") {
              kinds[key] = new BigNumber(element[key]);
            } else {
              kinds[key] = kinds[key].plus(new BigNumber(element[key]));
            }
          }
        }
      }
      this.totalMoney = kinds;
    }
  },
  created() {
    this.getInit();
  },
  mounted() {
    this.init();
    this.loadJqRiLi();
  }
};
</script>

<style lang='scss' scoped>
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
@import "~@fullcalendar/timegrid/main.css";
.calcendarWrapper {
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
  background-color: #ffffff;
}
#calcendarWrapper {
  margin-bottom: 40px;
}
.calcendarWrapper-top {
  margin: 0 0 3em;
}
.calcendarWrapper-calendar {
  margin: 0 auto 5px 0;
  padding: 10px;
  max-width: 98%;
}
/deep/ .fc-unthemed td.fc-today {
  background: transparent;
}
/deep/ .fc-bgevent {
  background: #1abc9c !important;
  opacity: 1;
}
/deep/ .fc-day-top .fc-day-number {
  font-size: 1.5em;
  font-weight: bold;
  padding: 20px 0 0;
  text-align: center;
  clear: both;
}
/deep/ .fc-ltr .fc-dayGrid-view .fc-day-top .fc-day-number {
  width: 100%;
}
.result {
  width: 94%;
  margin-top: 13%;
}
.btn-unblock {
  outline: none;
  border: none;
  text-align: center;
  padding: 0;
  margin-top: -5px;
  height: 20px;
}
.wenhao {
  font-size: 14px;
  width: 8px;
  height: 14px;
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 1px 5px;
  background-color: rgb(221, 221, 221);
}
.well {
  min-height: 20px;
  min-width: 100px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  .item-money {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/ .fc-event-container .fc-day-grid-event {
  color: #303133;
  font-size: 18px;
  border: none;
  text-align: center;
  margin-top: 5px;
  font-weight: 600;
}
[v-cloak] {
  display: none;
}
#backParent {
  position: absolute;
  top: 146px;
  right: 80px;
}
/deep/ .fc-event-container .fc-content .fc-title {
  display: table-cell;
  width: 100%;
  white-space: pre-line;
}
/deep/ .fc-scroller.fc-day-grid-container {
  height: fit-content !important;
}
@media only screen and (max-width: 750px) {
  .calcendarWrapper-calendar {
    max-width: 100%;
  }
  .result {
    width: 100%;
    margin-top: 5%;
  }
}

</style>